import { useContent } from "../context/ContentContext";
import { imgUrl } from "../lib/api";

export const Logo = ({ className = "h-10 w-auto" }) => {
  const content = useContent();
  const src = content?.logo ? imgUrl(content.logo) : "/logo.png";
  return (
    <img
      src={src}
      alt="Landerlan Dominicana"
      className={className}
      data-testid="brand-logo"
    />
  );
};
